import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { CreateAdminComponent } from './create-admin.component';

const routes: Routes = [
    {
        path     : 'create-admin',
        component: CreateAdminComponent,
        data :{
            permission:{
                only :['role1','role2']
            }
        },
        canActivate:[AuthGuard,RoleGuard]
    }
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
      CreateAdminComponent,
    ],
    providers:[
        AuthGuard,RoleGuard
    ]
})
export class CreateAdminModule { }



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/create-admin/create-admin.module.ts